export default __webpack_public_path__ + "static/media/gt.88fa3070.svg";